<template>
  <v-container>
    <loading
      :active="isloadagents"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <loading
      :active="isload"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <v-row class="mt-3">
      <v-col
        cols="12"
        v-if="isTrans == 'true'"
        class="d-flex w-100 justify-content-end"
      >
        <v-btn color="primary" @click="onClickCancel">
          {{ $t("cancel_beneficary") }}</v-btn
        >
      </v-col>
      <v-col cols="12" md="6">
        <label>{{ $t("country") }}<span style="color: #f00">*</span></label>
        <v-autocomplete 
          v-model="beneficiaryReqBody.country_name"
          :placeholder="$t('country')"
          :items="country_options"
          :error-messages="benificiaryCountryErrors"
          :disabled="ispaymodedisable"
          @input="$v.beneficiaryReqBody.country_name.$touch()"
          required
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <label
          >{{ $t("paymentMethod") }}<span style="color: #f00">*</span></label
        >
        <v-select 
          v-model="payment_method_selected"
          :placeholder="$t('paymentMethod')"
          :menu-props="{ bottom: true, offsetY: true }"
          :items="method_options"
          item-text="txt"
          item-value="val"
          :error-messages="paymentMethodErrors"
          @input="$v.payment_method_selected.$touch()"
          :disabled="ispaymodedisable"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col cols="12" md="6" v-if="payment_method_selected === 'B'">
        <label>{{ $t("bankName") }}<span style="color: #f00">*</span></label>
        <v-autocomplete 
          :placeholder="$t('bankName')"
          v-model="beneficiaryReqBody.bank_name"
          :items="bank_names"
          :error-messages="bankNameErrors"
          @input="$v.beneficiaryReqBody.bank_name.$touch()"
          required
          outlined
          dense
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6" v-if="payment_method_selected === 'B'">
        <label
          >{{ $t("branch_code_personal")
          }}<span
            style="color: #f00"
            v-if="
              this.beneficiaryReqBody.country_name === 'India' ||
              beneficiaryReqBody.country_name === 'Bangladesh'
            "
            >*</span
          >
          <br v-if="webbreakdown()" />
          <span v-if="this.beneficiaryReqBody.country_name === 'India'"
            >( ifsc code:
            <a href="https://www.ifsccodebank.com/" target="_blank"
              >www.ifsccodebank.com</a
            >
            )</span
          ></label
        >
        <v-text-field
          :placeholder="$t('branch_code_personal')"
          v-model="beneficiaryReqBody.branch_code"
          :error-messages="
            payment_method_selected === 'B' &&
            beneficiaryReqBody.country_name === 'India'
              ? branchCodeErrors
              : newBranchCodeErrors
          "
          @input="$v.beneficiaryReqBody.branch_code.$touch()"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6" v-if="payment_method_selected === 'B'">
        <label
          >{{ $t("account_number_personal")
          }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          :placeholder="$t('account_number_personal')"
          v-model="beneficiaryReqBody.bank_account_no"
          :error-messages="accountNoErrors"
          @input="$v.beneficiaryReqBody.bank_account_no.$touch()"
          required
          outlined
          dense
        >
        </v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="6"
        v-if="payment_method_selected != 'B' && payment_method_selected != 'A'"
      >
        <label
          >{{ $t("payoutLocation") }}<span style="color: #f00">*</span></label
        >
        <v-autocomplete 
          :placeholder="$t('payoutLocation')"
          v-model="beneficiary_payment_location"
          :items="payment_location"
          item-text="txt"
          item-value="val"
          :error-messages="payoutLocationErrors"
          @input="$v.beneficiary_payment_location.$touch()"
          required
          outlined
          dense
        ></v-autocomplete>
      </v-col>

      <v-col
        cols="12"
        md="6"
        v-if="
          payment_method_selected === 'A' &&
          beneficiaryReqBody.country_name === 'Indonesia'
        "
      >
        <label
          >{{ $t("Policy_Number") }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          :placeholder="$t('Policy_Number')"
          v-model="beneficiaryReqBody.policy_number"
          :disabled="true"
          :error-messages="policyNoErrors"
          @input="$v.beneficiaryReqBody.policy_number.$touch()"
          required
          outlined
          dense
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="12">
        <!-- <v-btn
            class="float-left mt-5 px-5 btn-primary-outlined text-capitalize"
            @click="$emit('onClickBack')"
            outlined
          >
            <v-icon dark left>mdi-arrow-left</v-icon>
            {{ $t("backLabel") }}
          </v-btn> -->
        <v-btn
          class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
          @click="onClickNext"
          outlined
        >
          {{ $t("next") }} <v-icon dark right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import {
  required,
  requiredIf,
  // numeric,
  alphaNum,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import commonService from "@/services/AgentCommonService/commonService.js";
// import { alpha } from "../../../utils/validate";
import { webbreakdown } from "../../utils/breakpoints";

export default {
  name: "AccountType",
  props: {
    policy_number: {
      type: String,
    },
    beneficiaryReqBody: {
      type: Object,
      required: true,
    },
    isTrans: {
      default: "",
      type: String,
    },
    loader: {
      type: Boolean,
      default: false,
    },
    createdBeneficiary: {
      type: Boolean,
    },
  },
  data() {
    return {
      webbreakdown,
      country_options: [],
      recieverDetails: {},
      country_obj: [],
      countryISO3: "IND",
      method_options: [],
      payment_location: [],
      payment_method_selected: {},
      bank_names: [],
      payment_location_name: "",
      payment_location_id: "",
      pay_crncy_cd: "INR",
      paying_cntry_cd: "IND",
      payment_mode_cd: "B",
      paying_cntry_name: "India",
      beneficiary_payment_location: {},
      selctedpaymentMode: "",
      ispaymodedisable: false,
      isloadagents: false,
      isload: false,
    };
  },
  components: {
    Loading,
  },
  validations() {
    return {
      payment_method_selected: {
        required,
      },
      beneficiary_payment_location: {
        required: requiredIf(function () {
          if (
            this.payment_method_selected != "B" &&
            this.payment_method_selected != "A"
          )
            return true;
          else return false;
        }),
      },
      beneficiaryReqBody: {
        country_name: {
          required,
        },
        bank_name: {
          required: requiredIf(function () {
            if (this.payment_method_selected === "B") return true;
            else return false;
          }),
          // alpha,
        },
        bank_account_no: {
          required: requiredIf(function () {
            if (this.payment_method_selected === "B") return true;
            else return false;
          }),
          alphaNum,
        },
        policy_number: {
          required: requiredIf(function () {
            if (
              this.payment_method_selected === "A" &&
              this.beneficiaryReqBody.country_name === "Indonesia"
            )
              return true;
            else return false;
          }),
          alphaNum,
        },
        branch_code: {
          minLength:
            this.payment_method_selected === "B" &&
            this.beneficiaryReqBody.country_name === "India"
              ? minLength(11)
              : false,
          maxLength:
            this.payment_method_selected === "B" &&
            this.beneficiaryReqBody.country_name === "India"
              ? maxLength(11)
              : false,
          required: requiredIf(function () {
            if (
              this.payment_method_selected === "B" &&
              this.beneficiaryReqBody.country_name === "India"
            )
              return true;
            else return false;
          }),
          alphaNum,
        },
      },
    };
  },
  computed: {
    ...mapGetters({ myPaymode: "getpaymodeCountry" }),
    benificiaryCountryErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.country_name.$dirty) return errors;
      !this.$v.beneficiaryReqBody.country_name.required &&
        errors.push(this.$t("select_beneficiary"));
      return errors;
    },
    paymentMethodErrors() {
      const errors = [];
      if (!this.$v.payment_method_selected.$dirty) return errors;
      !this.$v.payment_method_selected.required &&
        errors.push(this.$t("select_payment_method"));
      return errors;
    },
    bankNameErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.bank_name.$dirty) return errors;
      if (!this.$v.beneficiaryReqBody.bank_name.required) {
        errors.push(this.$t("select_bank_name"));
      }
      return errors;
    },
    accountNoErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.bank_account_no.$dirty) return errors;
      if (!this.$v.beneficiaryReqBody.bank_account_no.required) {
        errors.push(this.$t("account_number_valid"));
      }
      if (!this.$v.beneficiaryReqBody.bank_account_no.alphaNum) {
        errors.push(this.$t("account_number_valid"));
      }

      return errors;
    },
    policyNoErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.policy_number.$dirty) return errors;
      if (!this.$v.beneficiaryReqBody.policy_number.required) {
        errors.push(this.$t("policy_numb_req"));
      }
      if (!this.$v.beneficiaryReqBody.policy_number.alphaNum) {
        errors.push(this.$t("policy_numb_invalid"));
      }

      return errors;
    },
    branchCodeErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.branch_code.$dirty) return errors;
      !this.$v.beneficiaryReqBody.branch_code.required &&
        errors.push(this.$t("ifsc_code"));
      !this.$v.beneficiaryReqBody.branch_code.alphaNum &&
        errors.push(this.$t("invalid_ifsc_code"));
      !this.$v.beneficiaryReqBody.branch_code.minLength &&
        errors.push(this.$t("branch_code_minlength"));
      !this.$v.beneficiaryReqBody.branch_code.maxLength &&
        errors.push(this.$t("branch_code_minlength"));
      return errors;
    },
    newBranchCodeErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.branch_code.$dirty) return errors;
      !this.$v.beneficiaryReqBody.branch_code.required &&
        errors.push(this.$t("ifsc_code"));
      !this.$v.beneficiaryReqBody.branch_code.alphaNum &&
        errors.push(this.$t("invalid_ifsc_code"));
      return errors;
    },
    payoutLocationErrors() {
      const errors = [];
      if (!this.$v.beneficiary_payment_location.$dirty) return errors;
      !this.$v.beneficiary_payment_location.required &&
        errors.push(this.$t("select_payout_location"));
      return errors;
    },
  },
  watch: {
    policy_number: {
      immediate: true,
      handler(val) {
        this.beneficiaryReqBody.policy_number = val;
      },
    },
    selctedpaymentMode(newval) {
      console.log("PayMode :", newval);
    },
    "beneficiaryReqBody.country_name"(val) {
      this.paying_cntry_name = val;
      console.log("country name", val);
      this.country_obj.forEach((obj) => {
        console.log(obj.name);
        if (obj.country_name === val) {
          this.countryISO3 = obj.iso_alpha3;
          this.pay_crncy_cd = obj.currency_code;
          this.paying_cntry_cd = obj.iso_alpha3;
          this.getPaymentMode(obj.iso_alpha3);
        }
      });
      console.log("country chnaged:", this.payment_method_selected.length);
      if (this.payment_method_selected.length) {
        this.getpayLocation(this.payment_method_selected, this.countryISO3);
      } else {
        this.getpayLocation("B", this.countryISO3);
      }
    },
    payment_method_selected(newVal) {
      this.payment_mode_cd = newVal;
      console.log("payment_method_selected ", newVal);
      this.method_options.forEach((obj) => {
        if (obj.val === newVal) {
          console.log("payment_mode_name", obj);
          this.beneficiaryReqBody.payment_mode_name = obj.txt;
          this.getpayLocation(obj.val, this.countryISO3);
        }
      });
      console.log("this.method_options", this.method_options);

      if (newVal) this.beneficiaryReqBody.payment_mode = newVal;
    },
    beneficiary_payment_location(val) {
      this.payment_location_name = val.locationName;
      this.payment_location_id = val.locationId;
    },
    "beneficiaryReqBody.bank_name"(val) {
      console.log("beneficiaryReqBody.bank_nam", val);
      this.payment_location.map((i) => {
        if (i.txt === val) {
          this.payment_location_name = i.txt;
          this.payment_location_id = i.val.locationId;
        }
      });
      console.log("payment_location", this.payment_location);
    },
  },
  mounted() {
    this.getCountryList();
  },

  created() {},
  methods: {
    onClickCancel() {
      this.$router.push("/transaction/3");
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    onClickNext() {
      console.log("pay", this.beneficiaryReqBody);
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit(
        "onClickNext",

        Object.assign(this.beneficiaryReqBody, {
          country_code: this.countryISO3,
          // country_id: this.beneficiaryReqBody.country_name.id,
          country_name: this.beneficiaryReqBody.country_name,
          // bank_name: this.beneficiaryReqBody.bank_name,
          branch_code: this.beneficiaryReqBody.branch_code,
          bank_account_no: this.beneficiaryReqBody.bank_account_no,
          location_id: this.payment_location_id,
          location_name: this.payment_location_name,
          currency_code: this.pay_crncy_cd,
          payment_code: this.payment_mode_cd,
          mobile_number: this.paying_cntry_cd,
          policy_number: this.beneficiaryReqBody.policy_number,
          payment_mode_name: this.beneficiaryReqBody.payment_mode_name,
        })
      );
    },
    async getCountryList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((i) => {
            this.country_options.push(i.country_name);
            this.country_obj.push(i);
          });
          console.log("$store", this.$store.state.paymodeCountry);
          if (this.$store.state.paymodeCountry.country.name) {
            console.log("$store", this.$store.state.paymodeCountry);
            this.beneficiaryReqBody.country_name =
              this.$store.state.paymodeCountry.country.name;
          }
        }
      } catch (e) {
        console.error(e);
        this.country_options = [];
      }
    },

    async getPaymentMode(country_iso3) {
      this.isload = true;
      try {
        const responseData = await commonService.getpaymentModeByCntry({
          country_code: country_iso3,
        });
        console.log(responseData.data);
        if (responseData.status == 200) {
          this.method_options = await responseData.data.data.map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
          // mapping values coming from Amount section page
          if (this.$store.state.paymodeCountry.paymode) {
            this.ispaymodedisable = true;
            this.payment_method_selected =
              this.$store.state.paymodeCountry.paymode;
          } else {
            this.ispaymodedisable = false;
          }

          this.isload = false;
        } else {
          this.isload = false;
          this.method_options = [];
          return;
        }
      } catch (err) {
        this.isload = false;
        console.error(err);
        this.method_options = [];
        return;
      }
    },
    async getpayLocation(payment_mode, selected_country) {
      this.isloadagents = true;
      try {
        const responseData = await commonService.getbankList({
          country: selected_country,
          payment_mode: payment_mode,
        });
        console.log("getpayLocation:", responseData);
        if (responseData.status == 200) {
          this.payment_location = await responseData.data.data.map((i) => {
            return {
              txt: i.locationName,
              val: { locationId: i.locationId, locationName: i.locationName },
            };
          });
          console.log("this.payment_location", this.payment_location);
          this.bank_names = await responseData.data.data.map(
            (i) => i.locationName
          );
          this.isloadagents = false;
          console.log(this.beneficiaryReqBody.payment_mode);
        } else {
          this.isloadagents = false;
          this.payment_location = [];
          this.bank_names = [];
          return;
        }
      } catch (err) {
        this.isloadagents = false;
        console.error(err);
        this.payment_location = [];
        this.bank_names = [];
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
</style>
